// src/redux/deliveryApi.js
import { apiSlice } from "./apiSlice";

export const deliveryApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 탁송 리스트 조회: GET /api/user/delivery_order/v1
        getDeliveryOrders: build.query({
            query: (params) => ({
                url: "/api/user/delivery_order/v1",
                method: "get",
                params, // 예: { page, size, query, status, startDate, endDate }
                headers: { token: true },
            }),
        }),
        // 탁송 신청: POST /api/user/delivery_order/v1
        postDeliveryOrder: build.mutation({
            query: (body) => ({
                url: "/api/user/delivery_order/v1",
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),
        // 탁송 상세조회: GET /api/user/delivery_order/v1/{deliveryOrderId}
        getDeliveryOrderById: build.query({
            query: (deliveryOrderId) => ({
                url: `/api/user/delivery_order/v1/${deliveryOrderId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
    }),
});

export const { useGetDeliveryOrdersQuery, usePostDeliveryOrderMutation, useGetDeliveryOrderByIdQuery } = deliveryApi;
